module.exports = __webpack_public_path__ + "static/story5-cta-1920x515-8a6e23a0b3d376bb9f36a248862d7df3.jpg";